import i18n from 'i18next';
import { startCase } from 'lodash';
import { initReactI18next } from 'react-i18next';

// star import recommended from loader docs: https://github.com/alienfast/i18next-loader#option-1-use-with-webpackconfigjs-recommended
import { resources } from '../../../locales';

i18n.use(initReactI18next).init({
  compatibilityJSON: 'v3',
  debug: process.env.NODE_ENV !== 'production',
  defaultNS: 'app',
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false, // not needed for React
    format: (value, format) => {
      if (format === 'capitalize') return startCase(value);

      return value;
    },
  },
  lng: 'en',
  react: { useSuspense: false },
  resources,
});

export default i18n;
